<template>
  <div id="fh5co-wrapper">
  <div id="fh5co-page">
  <Header></Header>
  <div id="fh5co-team-section" class="fh5co-lightgray-section">
    <div class="container">
      <div class="heading-section text-center animate-box">
        <h2>お問合せ</h2>
      </div>
      <div class="privacy-container">
        <div class="vue">
          <ul class="tabs">
            <li v-on:click="change('1')" v-bind:class="{'active': isActive === '1'}">請求</li>
            <!-- <li v-on:click="change('2')" v-bind:class="{'active': isActive === '2'}">登録</li> -->
            <!-- <li v-on:click="change('3')" v-bind:class="{'active': isActive === '3'}">解約</li> -->
            <li v-on:click="change('4')" v-bind:class="{'active': isActive === '4'}">サービス</li>
            <li v-on:click="change('5')" v-bind:class="{'active': isActive === '5'}">お問合せ</li>
          </ul>
          <ul class="contents">
            <li v-if="isActive === '1'">
              <div>
                <h2>請求について</h2>
                <dl>
                  <dt>領収書の発行は可能でしょうか。</dt>
                  <dd>
                    恐れ入りますが、Legame onlineでは領収書の発行が不可となっております。<br>
                    ご契約状況・お支払い状況は、AppleまたはGoogleより発行される明細書でご確認お願いいたします。<br>
                    利用明細書は領収書と同じ扱いではありませんが、何卒ご了承ください。<br>
                    ※法人契約につきましては、各種承ります。
                  </dd>
                  <dt>消費税の適用について</dt>
                  <dd>
                    消費税率の変更に伴い、Legame onlineのご利用料金にも消費税率に変更がございます。<br>
                    この先、消費税率が現行の10％から変更になる際に、料金改定がある場合がございますので、ご了承ください。<br>
                    これに伴いまして、料金改定の前には事前にメールで連絡をさせていただきます。<br>
                    なお、既にお支払いが完了している月に関しては、追加でご請求が発生することはございません。
                  </dd>
                  <!-- <dt>クレジットカード以外での支払いは可能ですか？</dt>
                  <dd>
                    申し訳ございませんが、Legame onlineではクレジットカードのお支払いのみ対応となります。
                  </dd>
                  <dt>請求日はいつになりますか？</dt>
                  <dd>
                    利用料金は、契約者の登録の申請が承諾された日に拘わらず、その月の 1 日～末日の期間とした利用料金を支払うこととし、日割計算を行わないものとします。<br>
                    契約者は、登録月の翌月からは、毎月１日～末日の利用料金を、毎月１日に当社の定める方法で支払うものとし、日割計算を行わないものとします。
                  </dd> -->
                </dl>
              </div>
            </li>
            <li v-else-if="isActive === '2'">
              <div>
                <h2>登録について</h2>
                <dl>
                  <dt>登録の流れ</dt>
                  <dd>
                    <ol>
                      <li>
                        コースを選ぶ<br>
                        <a href="/course" title="コース一覧">&gt; コース一覧</a>
                      </li>
                      <li>
                        Coubicサイトで<a href="https://coubic.com/legame/products#pageContent" target="_blank" rel="noopener noreferrer">会員登録</a>
                      </li>
                      <li>
                        アクセス許可待ち<br>
                        当店の２営業日以内に、動画アプリ・食事Bookを利用するためのアカウントを発行いたします。<br>
                        アクセスできるようになるのをお待ちください。<br>
                        <small>※アカウント発行後、メール等でお知らせはございませんのでご了承ください。</small>
                      </li>
                      <li>
                        動画アプリ＋食事Bookサイトへアクセス<br>
                        <a href="/menu" title="会員メニュー">会員メニュー</a>にアクセスし、アプリをダウンロード（Webでご利用いただく場合は「トレーニングアプリ」をクリックしてください）<br>
                        Coubicサイトで会員登録したメールアドレスと同じメールアドレスでパスワード設定。<br>
                        <small>※３のアクセス許可が完了していない状態でパスワード設定をしようとすると「未登録のメールアドレスです。」と表示されます。アクセス許可までお待ちください。</small><br>
                        <small>※Coubicサイトで登録したメールアドレスのみでしか動画＋食事Bookの閲覧は出来ません。</small>
                      </li>
                      <li>
                        パスワード設定後<br>
                        動画＋食事Bookの閲覧が可能です。
                        動画はWeb、Android・iOSアプリで視聴可能です。<br>
                        食事Bookは<a href="/book" title="食事Book">こちら</a>で見ることが出来ます（印刷も可能）
                      </li>
                      <li>
                        更なる「宅ジム」パフォーマンスアップ<br>
                        当店ではTRXサスペンションの使用を推奨しております。<br>
                        詳しくは下記にてご確認ください。<br>
                        <a href="/trx" title="TRX紹介ページ">TRX紹介ページ</a>
                      </li>
                      <li>
                        パーソナルトレーニングコース<br>
                        こちらのコースに登録した方は、別途「あすけん」のプレミアムIDを発行し、メールでご連絡いたします。<br>
                        また、下記よりパーソナルトレーニングの予約を行ってください。<br>
                        <a href="https://coubic.com/legame/services#pageContent" title="パーソナルトレーニングの予約" target="_blank" rel="noopener noreferrer">https://coubic.com/legame/services#pageContent（外部サイト）</a>
                      </li>
                    </ol>
                  </dd>
                  <dt>自分のアカウント情報はどちらで見れますか？</dt>
                  <dd>
                    <a href="https://coubic.com/" title="coubic.com" target="_blank" rel="noopener noreferrer">coubic.com（外部サイト）</a>にアクセスし、ログインをしてください。
                  </dd>
                  <dt>キャンペーンについて</dt>
                  <dd>
                    キャンペーンについては新規の方が適用となっており、原則入会時にお一人様一度限りとなっております。<br>
                    このため、ご契約いただいた際に適用になったキャンペーンのみ適用となります。
                  </dd>
                  <dt>Coubicのパスワードの変更について</dt>
                  <dd>
                    Coubicサイトにログイン後、パスワード再設定画面 にて、登録している Eメールアドレスを入力し、STORES予約 から送られてくるメール記載のURLをクリックしますと、パスワードの変更を行うことができます。
                  </dd>
                  <dt>動画アプリ・食事Bookのパスワードの変更について</dt>
                  <dd>
                    一度ログアウトしてからログイン画面の下部にある「パスワード設定がお済みでない方はこちら」のフォームにメールアドレスを入力し、パスワード設定ボタンをクリックしてください。入力したメールアドレス宛てにパスワード再設定用のリンクが記載されたメールが送信されるので、リンクをクリックし、パスワードを変更してください。
                  </dd>
                </dl>
              </div>
            </li>
            <li v-else-if="isActive === '3'">
              <div>
                <h2>解約について</h2>
                <dl>
                  <dt>Legame onlineを退会する</dt>
                  <dd>
                    前月末日までの申告で、翌月末日での解約が可能となります。<br>
                    なお、契約期間内の解約はできません。詳細は<a href="/static/rules.pdf" title="利用規約" target="_blank">利用規約</a>第６条をご確認ください。<br>
                    上記を確認の上『taku-gym@legame-online.com』までご連絡ください。
                  </dd>
                </dl>
              </div>
            </li>
            <li v-else-if="isActive === '4'">
              <div>
                <h2>各サービスについて</h2>
                <dl>
                  <dt>動画について</dt>
                  <dd>
                    Legame onlineの動画が再生されない・途中で固まってしまう、このような場合、ネットワーク環境が極度に弱い状態である可能性が考えられます。<br>
                    恐れ入りますが、ご利用のネットワークの通信環境をご確認のうえ再度ご視聴をお試しください。
                  </dd>
                  <!-- <dt>食事Bookについて</dt>
                  <dd>
                    会員登録後『<a href="/menu" title="会員メニュー">こちらの会員メニュー</a>』よりログインして頂くと閲覧が可能となります。<br>
                    なお、印刷することも可能です。
                  </dd> -->
                  <dt>TRXサスペンションについて</dt>
                  <dd>
                    更なる「宅ジム」としてのパフォーマンスアップの為、Legame onlineではTRXサスペンションの使用を推奨しております。<br>
                    詳しくは下記にてご確認ください。<br>
                    <a href="/trx" title="TRX紹介ページ">TRX紹介ページ</a>
                  </dd>
                  <!-- <dt>パーソナルトレーニングについて</dt>
                  <dd>
                    予約サイトよりパーソナルトレーニングの予約が可能です。<br>
                    <a href="https://coubic.com/legame/928383#pageContent" title="coubic" target="_blank" rel="noopener noreferrer">coubic.com（外部サイト）</a>より、ご自身のご希望する日時で予約をお願い致します。
                  </dd> -->
                </dl>
              </div>
            </li>
            <li v-else-if="isActive === '5'">
              <div>
                <h2>お問合せ</h2>
                <dl>
                  <dt>電話によるお問合せは可能ですか？</dt>
                  <dd>
                    申し訳ございませんが、電話による対応は行なっておりません。<br>
                    ご連絡は『taku-gym@legame-online.com』までお願い致します。<br>
                    なお、ご返信は２営業日以内での対応でご返信させていただきますので、ご返信をお待ちください。
                  </dd>
                </dl>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</div>
</div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Contact',
  components: {
    Header,
    Footer
  },
  data: function () {
    return {isActive: '1'}
  },
  methods: {
    change: function(num) {
      this.isActive = num
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.privacy-container{
  background-color: #fff;
  padding: 20px;
}
.privacy-container h2{
  font-size: 20px;
  font-weight: bold;
  border-bottom: 3px #cdff19 solid;
  margin-bottom: 5px;
  padding-bottom: 5px;
  padding-top: 20px;
}
.privacy-container p{
  font-size: 18px;
}

ul{
  margin: 0;
  padding: 0;
}
ul>li{
  list-style: none;
}
.tabs {
  overflow: hidden;
}
.tabs>li {
  float: left;
  padding: 10px 20px;
  border: 2px solid #eee;
  cursor: pointer;
  transition: .3s;
  background-color: #f5f5f5;

}
.tabs li:not(:first-child),
.tabs label:not(:first-of-type) {
  border-left: none;
}
.tabs>li.active {
  background-color: #cdff19;
  border-color: #cdff19;
  color: #333;
  cursor: auto;
}
.contents{
  overflow: hidden;
  margin-top: -1px;
}
.contents>li {
  padding: 20px;
  border: 2px solid #eee;
}

dl dd{
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 20px;
}

ol li{
  padding-bottom: 10px;
}
@media screen and (max-width: 640px) {
  .tabs li{
    padding: 3px 4px;
    font-size: 12px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue